var map = {
	"./date.de-CH.json": 874,
	"./date.de-DE.json": 875,
	"./date.en-CA.json": 876,
	"./date.en-GB.json": 877,
	"./date.en-IN.json": 878,
	"./date.en-ME.json": 879,
	"./date.en-US.json": 880,
	"./date.es-EM.json": 881,
	"./date.es-ES.json": 882,
	"./date.fr-BE.json": 883,
	"./date.fr-CA.json": 884,
	"./date.fr-CH.json": 885,
	"./date.nl-BE.json": 886,
	"./date.nl-NL.json": 887,
	"./date.pl-PL.json": 888,
	"./date.pt-BR.json": 889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 873;